import reddit from "./components/Editor/scripts/reddit";
import pseudoBank from "./components/Editor/scripts/pseudo-bank";

export const DEFAULT_SCRIPT =
  window.location.hostname === "localhost" ? pseudoBank : reddit;
